export const defaultImageCardDimensions = {
	width: 156,
	height: 125,
} as const;
